// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBFa9NMmKYhMB-aXa1eLN2k4DIApGMqUuk",
  authDomain: "my-portfolio-77cbc.firebaseapp.com",
  projectId: "my-portfolio-77cbc",
  storageBucket: "my-portfolio-77cbc.appspot.com",
  messagingSenderId: "570014106391",
  appId: "1:570014106391:web:ae1d4446d05d07741aad52",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const fireStoredb = getFirestore(app);
export const storage = getStorage(app);
